import { useState, MouseEvent, ReactNode, Fragment } from 'react';
import { selectL10N } from '@features/ui/UiSlice';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { useResize } from '@hooks/useResize';
import { numberWithCommas } from '@utils/index';
import type { l10nType } from '@type/index';

const ResultCount = ({ l10nTemplate, totalCount }: { l10nTemplate: l10nType[keyof l10nType]; totalCount?: number }) => {
  return (
    <div className="result-count">
      {typeof totalCount === 'number' ? (
        <Fragment>
          {l10nTemplate['result']}
          <strong>{numberWithCommas(totalCount) || '0'}</strong>
          {l10nTemplate['count']}
        </Fragment>
      ) : (
        <Fragment />
      )}
    </div>
  );
};

const BtnFilterToggle = ({ isActive, clickCallback }: { isActive: boolean; clickCallback: (e: MouseEvent<HTMLButtonElement>) => void }) => {
  return <button className={`btn-filter-toggle ${isActive ? 'active' : ''}`} onClick={clickCallback}></button>;
};

const PcUi = ({ totalCount, filter }: { totalCount?: number; filter?: ReactNode }) => {
  const l10n = useAppSelector(selectL10N)!;
  return (
    <div className="search-header-wrap">
      <ResultCount l10nTemplate={l10n['template']} totalCount={totalCount} />
      {filter ? <div className="search-filter-wrap">{filter}</div> : <Fragment />}
    </div>
  );
};

const MobileUi = ({ totalCount, filter }: { totalCount?: number; filter?: ReactNode }) => {
  const l10n = useAppSelector(selectL10N)!;
  const [isActive, setIsActive] = useState(false);

  const btnClickCallback = (e: MouseEvent<HTMLButtonElement>) => {
    setIsActive(!isActive);
  };

  return (
    <Fragment>
      <div className="search-header-wrap">
        {filter ? <BtnFilterToggle isActive={isActive} clickCallback={btnClickCallback} /> : <Fragment />}
        <ResultCount l10nTemplate={l10n['template']} totalCount={totalCount} />
      </div>
      {filter ? <div className={`search-header-wrap filter-wrap ${isActive ? 'active' : ''}`}>{filter}</div> : <Fragment />}
    </Fragment>
  );
};

const Header = ({ totalCount, children }: { totalCount?: number; children?: ReactNode }) => {
  const { isPcWidth } = useResize();

  return (
    <section className="search-header">
      {isPcWidth ? <PcUi totalCount={totalCount} filter={children} /> : <MobileUi totalCount={totalCount} filter={children} />}
    </section>
  );
};

export default Header;
